const ALIGN = { left: "text-left", center: "text-center", right: "text-right" };

export const RichText = ({ text, align = "center", className = "", testId }) => (
  <p className={`whitespace-pre-line ${ALIGN[align] || ALIGN.center} ${className}`} data-testid={testId}>
    {text.split(/(\*\*[^*\n]+\*\*)/g).map((part, i) =>
      /^\*\*[^*\n]+\*\*$/.test(part) ? <strong key={i} className="font-semibold text-slate-50">{part.slice(2, -2)}</strong> : part)}
  </p>
);
